import { t } from '@ctcells/i18n'

import { StatusBadge } from '../../atoms/StatusBadge.tsx'
import type { RecipeVocabularyNote } from '../recipes/recipeVocabulary.ts'

/**
 * 새 작업 창 사전 점검 자리의 **프론트 대조 한 줄** — 고른 레시피에 은퇴 스텝 이름이 있으면 알린다.
 *
 * 🔴 **추론이 아니라 표 대조다**(`@ctcells/core` `recipeStepVocabulary.ts`). 막지 않는다 — 생성·점검은
 *    그대로 열려 있고 최종 판정은 서버다. 사전 점검 결과(`PreflightReport`)와 같은 칸 모양을 빌리되
 *    제목이 「화면 대조」라 서버가 낸 항목과 섞여 읽히지 않는다.
 * ⚠ 까닭(2026-09-26 실측): 옛 `centrifuge.pick` 이 든 레시피가 시작 직후 `paused` 로 멎었고, 사전 점검은
 *   그것을 이름으로 짚지 못했다(`SEQUENCE_UNSUPPORTED_AT_START` · `item: null` 「요구를 못 셈」).
 */
export function RecipeVocabularyReport({ note }: { note: RecipeVocabularyNote | undefined }) {
  if (note === undefined) return null
  return (
    <ul aria-label={t('recipe.vocab.title')} className="pfblk">
      <li className="pfblk__item">
        <div className="pfblk__head">
          <StatusBadge label={t('enum.severity.WARN')} status="WARN" />
          <span className="pfblk__title">{t('recipe.vocab.title')}</span>
        </div>
        {note.retired.length === 0 ? null : (
          <div className="pfblk__action">
            {t('recipe.vocab.retired', { names: note.retired.join(' · ') })}
          </div>
        )}
        {note.unknown.length === 0 ? null : (
          <div className="pfblk__action">
            {t('recipe.vocab.unknown', { names: note.unknown.join(' · ') })}
          </div>
        )}
      </li>
    </ul>
  )
}
